import React from 'react';
import { Link } from 'react-router-dom';
import logoImg from '../assets/blast-logo.webp';

const sectionTitle = { fontSize: 'clamp(20px, 3vw, 28px)', fontWeight: 900, fontStyle: 'italic', margin: '32px 0 16px' };
const subTitle = { fontSize: 16, fontWeight: 800, margin: '20px 0 8px' };
const paragraph = { color: '#c8ccd3', fontSize: 14, lineHeight: 1.7, marginBottom: 10 };
const listStyle = { color: '#c8ccd3', fontSize: 14, lineHeight: 1.7, marginBottom: 10, paddingLeft: 20 };

export default function PrivacyPolicy() {
  return (
    <div style={{ background: '#12151A', color: '#F0EDE4', minHeight: '100vh', fontFamily: "'Segoe UI', sans-serif" }}>
      <nav style={{ padding: '18px 6vw' }}>
        <Link to="/">
          <img src={logoImg} alt="Blast Motor Club" style={{ height: 36, width: 'auto' }} />
        </Link>
      </nav>

      <div style={{ padding: '0 6vw 80px', maxWidth: 780, margin: '0 auto' }}>
        <Link to="/" style={{ color: '#D02127', fontSize: 13, textDecoration: 'none' }}>← Beranda</Link>

        <span style={{ display: 'block', color: '#D02127', fontWeight: 800, fontSize: 12, letterSpacing: 3, textTransform: 'uppercase', marginTop: 20 }}>
          Legal
        </span>
        <h1 style={{ fontSize: 'clamp(28px, 5vw, 44px)', fontWeight: 900, fontStyle: 'italic', margin: '6px 0 4px' }}>
          Kebijakan Privasi & Syarat Ketentuan
        </h1>
        <p style={{ color: '#5a616e', fontSize: 12, marginBottom: 20 }}>Terakhir diperbarui: 10 Juli 2026</p>

        {/* BAGIAN 1 - PRIVASI */}
        <h2 style={sectionTitle}>Kebijakan Privasi</h2>

        <h3 style={subTitle}>1. Pendahuluan</h3>
        <p style={paragraph}>
          Blast Motor Club ("Kami", "Komunitas") mengelola situs ridewithblast.com beserta subdomain member dan admin yang menyertainya.
          Kebijakan Privasi ini menjelaskan bagaimana Kami mengumpulkan, menggunakan, menyimpan, dan melindungi data pribadi anggota
          ("Anda", "Member") yang menggunakan layanan Kami.
        </p>

        <h3 style={subTitle}>2. Data yang Kami Kumpulkan</h3>
        <ul style={listStyle}>
          <li><strong>Data akun:</strong> nama lengkap, alamat email, nomor telepon, kata sandi (tersimpan terenkripsi).</li>
          <li><strong>Data profil:</strong> foto profil, jenis motor, spesifikasi motor dan gear, biografi singkat.</li>
          <li><strong>Data kontak darurat:</strong> nama, nomor telepon, dan hubungan kontak darurat — hanya dapat diakses oleh pengurus (Ketua/Wakil Ketua/Pengurus) untuk keperluan keselamatan saat touring.</li>
          <li><strong>Data lokasi:</strong> koordinat GPS dikumpulkan secara real-time hanya selama Anda berpartisipasi aktif dalam sesi touring langsung (live touring) yang Anda mulai atau ikuti sendiri.</li>
          <li><strong>Konten yang Anda unggah:</strong> foto checkpoint touring, foto gear/motor, pesan di papan pesan komunitas.</li>
          <li><strong>Data teknis:</strong> alamat IP dan informasi perangkat dapat tercatat secara otomatis untuk keperluan keamanan sistem.</li>
        </ul>

        <h3 style={subTitle}>3. Bagaimana Kami Menggunakan Data Anda</h3>
        <ul style={listStyle}>
          <li>Menyediakan dan mengoperasikan fitur inti platform (profil member, touring, live tracking, papan pesan, galeri).</li>
          <li>Menampilkan profil publik Anda (nama, posisi, foto, spek motor/gear yang Anda pilih untuk ditampilkan) kepada pengunjung situs.</li>
          <li>Mengirimkan notifikasi terkait aktivitas komunitas (jika Anda mengaktifkan fitur terkait).</li>
          <li>Menjaga keamanan dan integritas platform, termasuk moderasi konten oleh admin.</li>
        </ul>

        <h3 style={subTitle}>4. Berbagi Data dengan Pihak Ketiga</h3>
        <p style={paragraph}>
          Kami <strong>tidak menjual</strong> data pribadi Anda kepada pihak ketiga. Data hanya dibagikan kepada penyedia layanan
          teknis yang mendukung operasional platform (hosting, penyimpanan foto), yang terikat kewajiban kerahasiaan, atau jika
          diwajibkan oleh hukum yang berlaku maupun permintaan resmi dari pihak berwenang.
        </p>

        <h3 style={subTitle}>5. Hak Anda</h3>
        <ul style={listStyle}>
          <li>Mengakses dan memperbarui data profil Anda kapan saja melalui halaman Edit Profil.</li>
          <li>Meminta penghapusan akun dan data terkait dengan menghubungi Kami.</li>
          <li>Membatasi informasi yang tampil di profil publik (kontak darurat tidak pernah ditampilkan ke publik).</li>
        </ul>

        <h3 style={subTitle}>6. Keamanan Data</h3>
        <p style={paragraph}>
          Kami menerapkan langkah teknis wajar untuk melindungi data Anda, termasuk enkripsi kata sandi dan pembatasan akses
          berbasis peran (member/pengurus/admin). Namun, tidak ada sistem yang sepenuhnya bebas risiko, dan Anda bertanggung jawab
          menjaga kerahasiaan kata sandi akun Anda.
        </p>

        <h3 style={subTitle}>7. Data Anak</h3>
        <p style={paragraph}>
          Layanan ini ditujukan bagi pengguna berusia 17 tahun ke atas atau telah memiliki SIM yang sah. Kami tidak secara sengaja
          mengumpulkan data dari anak di bawah usia tersebut.
        </p>

        {/* BAGIAN 2 - SYARAT KETENTUAN */}
        <h2 style={sectionTitle}>Syarat & Ketentuan Penggunaan</h2>

        <h3 style={subTitle}>1. Penerimaan Ketentuan</h3>
        <p style={paragraph}>
          Dengan mendaftar dan menggunakan ridewithblast.com, Anda menyetujui seluruh syarat dan ketentuan berikut. Jika Anda
          tidak setuju, mohon untuk tidak menggunakan layanan ini.
        </p>

        <h3 style={subTitle}>2. Keanggotaan</h3>
        <ul style={listStyle}>
          <li>Pendaftaran member baru akan berstatus "belum disetujui" hingga diverifikasi oleh pengurus.</li>
          <li>Kami berhak menangguhkan (suspend) atau menghapus akun yang melanggar ketentuan ini atau merugikan komunitas.</li>
          <li>Anda bertanggung jawab penuh atas keakuratan data yang Anda daftarkan.</li>
        </ul>

        <h3 style={subTitle}>3. Touring dan Aktivitas Berkendara</h3>
        <ul style={listStyle}>
          <li><strong>Risiko berkendara ditanggung sendiri.</strong> Blast Motor Club memfasilitasi koordinasi touring (baik touring resmi maupun touring santai) namun tidak bertanggung jawab atas kecelakaan, cedera, kehilangan, atau kerusakan yang terjadi selama kegiatan berkendara.</li>
          <li>Setiap peserta wajib mematuhi peraturan lalu lintas yang berlaku dan menggunakan perlengkapan keselamatan berkendara yang layak.</li>
          <li>Fitur live touring dan checkpoint bersifat sukarela dan digunakan atas risiko serta kebijaksanaan pengguna sendiri, termasuk berbagi lokasi real-time.</li>
          <li>Member yang memulai touring santai bertindak sebagai koordinator sukarela, bukan perwakilan resmi organisasi kecuali dinyatakan lain oleh pengurus.</li>
        </ul>

        <h3 style={subTitle}>4. Konten Pengguna</h3>
        <ul style={listStyle}>
          <li>Anda tetap memiliki hak atas foto dan konten yang Anda unggah, namun memberikan izin kepada Blast Motor Club untuk menampilkannya di platform (profil, galeri, papan pesan) sebagai bagian dari layanan komunitas.</li>
          <li>Dilarang mengunggah konten yang melanggar hukum, mengandung ujaran kebencian, pelecehan, atau melanggar hak pihak lain.</li>
          <li>Kami berhak menghapus konten yang melanggar ketentuan ini tanpa pemberitahuan sebelumnya.</li>
        </ul>

        <h3 style={subTitle}>5. Perilaku Komunitas</h3>
        <p style={paragraph}>
          Anggota diharapkan menjaga sikap saling menghormati di seluruh interaksi komunitas (papan pesan, touring, galeri).
          Pelanggaran berulang dapat mengakibatkan penangguhan atau pencabutan keanggotaan oleh pengurus.
        </p>

        <h3 style={subTitle}>6. Batasan Tanggung Jawab</h3>
        <p style={paragraph}>
          Layanan disediakan "sebagaimana adanya". Blast Motor Club tidak menjamin platform akan selalu bebas dari gangguan teknis
          dan tidak bertanggung jawab atas kerugian tidak langsung yang timbul dari penggunaan layanan, termasuk namun tidak
          terbatas pada kehilangan data atau gangguan akses sementara.
        </p>

        <h3 style={subTitle}>7. Perubahan Ketentuan</h3>
        <p style={paragraph}>
          Kami dapat memperbarui Kebijakan Privasi dan Syarat Ketentuan ini sewaktu-waktu. Perubahan signifikan akan diinformasikan
          melalui platform. Penggunaan berkelanjutan setelah perubahan dianggap sebagai persetujuan Anda terhadap ketentuan yang
          diperbarui.
        </p>

        <h3 style={subTitle}>8. Hukum yang Berlaku</h3>
        <p style={paragraph}>
          Ketentuan ini diatur oleh dan ditafsirkan sesuai dengan hukum Republik Indonesia.
        </p>

        <div style={{ background: '#1C2128', border: '1px solid #262b33', borderRadius: 8, padding: 20, marginTop: 32 }}>
          <h3 style={{ ...subTitle, marginTop: 0 }}>Kontak</h3>
          <p style={paragraph}>
            Untuk pertanyaan seputar privasi data, permintaan penghapusan akun, atau hal lain terkait ketentuan ini, silakan hubungi:
          </p>
          <p style={{ color: '#2B6996', fontSize: 14, fontWeight: 700 }}>info@ridewithblast.com</p>
        </div>
      </div>

      <footer style={{ padding: '32px 6vw', borderTop: '1px solid #262b33', textAlign: 'center', color: '#5a616e', fontSize: 12 }}>
        © 2026 Blast Motor Club
      </footer>
    </div>
  );
}
